import { Popper } from '@cian/ui-kit/internal/components/Popper';
import React, { type RefObject } from 'react';

import styles from './DynamicPhoneTooltip.css';

type TPopperModifier = NonNullable<React.ComponentProps<typeof Popper>['modifiers']>[number];

/**
 * Тултип шире колонки сниппета, из-за чего popper по умолчанию менял вариант
 * bottom-start → bottom-end и уводил его левее номера.
 * Переопределения мержатся по name, поэтому phase/fn тут не нужны.
 */
const MODIFIERS = [
  { name: 'flip', options: { flipVariations: false } },
  { name: 'preventOverflow', options: { altAxis: true } },
] as unknown as TPopperModifier[];

interface IDynamicPhoneTooltipProps {
  open: boolean;
  anchorRef: RefObject<HTMLElement | null>;
  children: string;
}

const TOOLTIP_Z_INDEX = 10;

/** Собран на internal Popper: CustomTooltip не даёт стилизовать бокс под макет */
export const DynamicPhoneTooltip: React.FC<IDynamicPhoneTooltipProps> = ({ open, anchorRef, children }) => {
  return (
    <Popper anchorRef={anchorRef} modifiers={MODIFIERS} open={open} placement="bottom-start" zIndex={TOOLTIP_Z_INDEX}>
      {/* отступ от номера живёт на вложенном блоке: popper ставит инлайн margin: 0 на элемент, который позиционирует */}
      <div className={styles['tooltip']}>{children}</div>
    </Popper>
  );
};

DynamicPhoneTooltip.displayName = 'DynamicPhoneTooltip';
